import { FC, ButtonHTMLAttributes } from 'react'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

export const RetroButton: FC<Props> = ({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  disabled,
  ...props
}) => {
  const variantClasses = {
    default: 'retro-btn',
    primary: 'retro-btn retro-btn-primary',
    danger: 'retro-btn bg-game-loss border-game-loss text-white hover:bg-red-700',
  }

  const sizeClasses = {
    sm: 'px-2 py-1 text-pixel-xs',
    md: 'px-4 py-2 text-pixel-sm',
    lg: 'px-6 py-3 text-pixel-base',
  }

  return (
    <button
      className={`
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
